import Immutable from 'immutable';

export function callbackHandler(cb, entityLabel) {
  return (map, action) => {
    cb(map, action, entityLabel);
  };
}

export function merge(map, action, entityLabel) {
  const payload     = action.payload || {};
  const normalized  = payload.normalized || {};
  const entities    = normalized.entities || {};
  const entity      = entities[entityLabel];

  return map.merge(Immutable.fromJS({
    result: normalized.result,
    data:   entity
  }));
}

export function mergeObject(map, action) {
  const payload     = action.payload || {};
  const normalized  = payload.normalized || {};
  const entities    = normalized.entities;

  return map.merge(Immutable.fromJS({
    result: normalized.result,
    data:   entities
  },function (key, value, path) {
        return value.toOrderedMap()
    }));
}

export function remove(map, action) {
  const payload = action.payload;
  const data    = map.get('data') || Immutable.Map();

  let newResult = map.get('result') || Immutable.List();

  const indexToDelete = newResult.indexOf(payload.id);

  if (indexToDelete !== -1) {
    newResult = newResult.delete(indexToDelete);
  }

  return map.merge(Immutable.fromJS({
    result: newResult,
    data:   data.remove(payload.id)
  }));
}

export function replace(map, action, entityLabel) {
  const data        = map.get('data') || Immutable.Map();
  const normalized  = action.payload.normalized || {};
  const entities    = normalized.entities || {};
  const entity      = entities[entityLabel];
  let newData = data;

  if (normalized) {
    newData = newData.merge(Immutable.fromJS(entity));
  }

  return map.set('data', newData);
}



// WEBPACK FOOTER //
// ./app/lib/mapReducerHelpers.js